<div class="root" [class.short-height]="shortHeight" [class.selected]="selected" [class.disabled]="isDisabled" [class.finished]="finished" (click)="emitClick()">
  <div class="description">
    <div *ngIf="stepperItem.number" class="number-circle" [class.disabled]="isDisabled" [class.finished]="finished">{{ stepperItem.number }}</div>

    <span class="text" [class.large-font]="largeFont" [class.disabled]="isDisabled">{{ stepperItem.text }}</span>
  </div>

  <div *ngIf="!selected" class="icon" [class.finished]="finished">
    <app-lucide-icon  [iconName]="iconName" [size]="24"></app-lucide-icon>
  </div>
</div>

<div *ngIf="selected" class="deselector-container">
  <app-button [text]="'Alterar Resposta'" [outline]="true" (clickEvent)="emitClick(true)"></app-button>
</div>
